import idx from 'idx';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import PricingCategory from 'marketing/components/pricing_category';
import { getSubCategories } from 'common/ducks/categories';

export const FORM_NAME = 'PRICING_CATEGORY_FORM';

export function mapStateToProps({ categories }) {
  const subcategories = getSubCategories(categories);
  const logoSubCat = subcategories.find(({ name }) => name.toLowerCase() === 'logo');
  const initialValues = logoSubCat ? { category: logoSubCat.id } : {};

  return {
    formName: FORM_NAME,
    initialValues,
  };
}

const PricingCategoryForm = reduxForm({ form: FORM_NAME })(PricingCategory);

export default connect(mapStateToProps)(PricingCategoryForm);



// WEBPACK FOOTER //
// ./marketing/containers/pricing_category.js